import { Component, OnDestroy } from '@angular/core';
import { AuthService } from '@core/services';
import { AppConstants } from '@root/app/app.constants';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [],
  template: '',
  styles: '',
})
export class LogoutComponent implements OnDestroy {
  private readonly subscriptions = new Subscription();

  constructor(private readonly authService: AuthService) {
    this.subscriptions.add(
      this.authService
        .checkForB2CActiveAccount()
        .subscribe(() => {
          localStorage.removeItem(AppConstants.ID_TOKEN);
          localStorage.removeItem(AppConstants.SSO_TOKEN);
          this.authService.navigateToLoginPage();
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
